export class Playlist {
  public id: number;
  public name: string;
  public order: number;
  public thumbnail: string;
  public items: any[];

  constructor(data: any = {}) {
    this.id = data.id || null;
    this.name = data.name || null;
    this.order = data.order || null;
    this.thumbnail = data.thumbnail || '';
    this.items = data.items || [];
  }
}
